$(document).ready(function() {
    $(".js-videopitch").each(function() {
        
        var $el = $(this);
        var url = $el.attr('data-videopitch');

        var id;

        id = getYouTubeVideoIdFromUrl(url);

        if (id){
            console.log("id", id);
            var replacement = `<iframe width="100%" height="100%" src="//www.youtube.com/embed/${id}" frameborder="0" allowfullscreen></iframe>`;
            $el.find(".js-videopitch-container").html(replacement);
        } else {
            id = getVimeoIdFromUrl(url);

            if (id) {
                var replacement = `<iframe width="100%" height="100%" src="//player.vimeo.com/video/${id}" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>`;
                $el.find(".js-videopitch-container").html(replacement);
            }
        }
 
        console.log(replacement);

    })
})

function getYouTubeVideoIdFromUrl(url) {
    // Our regex pattern to look for a youTube ID
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    //Match the url with the regex
    const match = url.match(regExp);
    //Return the result
    return match && match[2].length === 11 ? match[2] : undefined;
  };


  function getVimeoIdFromUrl(url) {
    // Look for a string with 'vimeo', then whatever, then a
    // forward slash and a group of digits.
    const match = /vimeo.*\/(\d+)/i.exec(url);
    // If the match isn't null (i.e. it matched)
    if (match) {
      // The grouped/matched digits from the regex
      return match[1];
    }
  };


// WEBPACK FOOTER //
// ./app/src/assets/js/partials/videopitch.js